/* eslint-disable import/no-anonymous-default-export */
import requestOptions from '../services/requestOptions'
import businessMapper from '../models/Business_Mapper'
import apiValidation from '../validation/ApiRespValidation'

const establishmentService = async (paremeters) => {
    try {
        const options = requestOptions.options('GET', paremeters, '')
        const resp = await fetch(global.ESTABLISHMENTS, options)
        const data = await resp.json();
        const apiValidationResp = apiValidation.apiValidation(data);
        let response = [];
        if (!apiValidationResp.error) {
            response = businessMapper.establishmentMapper(data.data);
        } else {
            localStorage.clear();
            window.location.href = '/';
        }
        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

const moduleService = async (paremeters, businessId) => {
    try {
        const options = requestOptions.options('GET', paremeters, '')
        const resp = await fetch(global.MODULES + '/' + businessId, options)
        const data = await resp.json();
        const apiValidationResp = apiValidation.apiValidation(data);
        let response = [];

        if (!apiValidationResp.error) {
            const menu = businessMapper.menuMapper(data.menu);
            const modules = businessMapper.moduleMapper(data.data);
            response[0] = modules;
            response[1] = menu;
        } else {
            localStorage.clear();
            window.location.href = '/';
        }

        return response;
    } catch (error) {
        return apiValidation.apiError500();
    }
}

export default {
    establishmentService,
    moduleService
}
